<template>
	<el-dialog class='dialog-statistics' title="数据共享统计" :visible.sync="dialogVisible" width="60%">
		<ul class="statistics-table">
			<li class="flex flex-row-between statistics-header">
				<p>序号</p>
				<p>报送单位</p>
				<p>报送总数（条）</p>
				<p>双公示信息数量（条）</p>
				<p>联合奖惩数量（条）</p>
				<p>其他信息数量（条）</p>
			</li>
			<li class="flex flex-row-between statistics-body" v-for="(item, index) in list" :key="index">
				<p>{{index+1}}</p>
				<p>{{item.fullName}}</p>
				<p>{{item.totalCount}}</p>
				<p>{{item.sgsCount}}</p>
				<p>{{item.lhjcCount}}</p>
				<p>{{item.qtCount}}</p>
			</li>
		</ul>
		<span slot="footer" class="dialog-footer">
			
		</span>
	</el-dialog>
</template>

<script>

export default {
	components: {},
	data() {
		return {
			dialogVisible: false,
			list: []
		};
	},
	computed: {},
	watch: {},


	methods: {

		show(v) {
			this.$set(this, 'dialogVisible', true)

			this.$set(this, 'list', v || []);
			console.log(this.list);
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' >
	.dialog-statistics {
        .el-dialog__body{
            padding: 0 15px;
            height: 500px;
            overflow-y: scroll;
        }
		& .statistics-table {
			& > li {
				&:nth-child(even) {
					background-color: #f6f6f6;
				}
				& > p {
					flex-basis: 20%;
					line-height: 50px;
					&:first-of-type {
						flex-basis: 10%;
					}
					&:nth-child(2) {
						flex-basis: 30%;
					}
				}
			}
			& > li.statistics-header {
				background-color: $red;
				& > p {
					line-height: 55px;
					color: #fff;
				}
			}
			& > li.statistics-body {
				&:nth-child(even) {
					background: #f9f9f9;
				}
				& > p {
					line-height: 55px;
				}
			}
		}
	}
</style>
